/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
/* eslint-disable no-var */
/* eslint-disable vars-on-top */
import { Chart } from 'react-chartjs-2';
import { Chart as ChartJS, registerables } from 'chart.js';
import React, { useRef } from 'react';

ChartJS.register(...registerables);

export default function EditsGraph({
  title,
  showXLabels,
  nameXAxis,
  xLables,
  yValuesLine,
  yValuesBar,
  height,
}: {
  title: string;
  showXLabels: boolean;
  nameXAxis: string;
  xLables: string[];
  yValuesLine: number[];
  yValuesBar: number[];
  height: number;
}): JSX.Element {
  const fontFamily = 'Roboto, sans-serif';
  const chartRef = useRef<any>();
  // const title = `${
  //   key[0].toUpperCase() + key.slice(1).toLowerCase()
  // }-Edit Distribution`;
  // const title = 'agetnlasfdj';

  const data = {
    labels: xLables,
    // indexAxis: 'y',
    datasets: [
      {
        label: 'Edit Rate',
        data: yValuesLine,
        type: 'line',
        yAxisID: 'right-y-axis',
        backgroundColor: 'rgba(0, 33, 49, 1)',
        borderColor: 'rgba(0, 33, 49, 0.5)',
        borderWidth: 1.5,
        pointRadius: 5,
        pointHoverRadius: 7,
        hoverBorderColor: 'rgb(59,134,254,1)',
        hoverBorderWidth: 4,
        fill: {
          target: 'origin',
          above: 'rgba(59,134,254,0.1)',
        },
      },
      {
        label: 'Total Calls',
        data: yValuesBar,
        type: 'bar',
        yAxisID: 'left-y-axis',
        backgroundColor: 'rgb(46,119,174,1)',
        hoverBackgroundColor: 'rgb(46,119,174,0.75)',
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
        display: false,
        labels: {
          fontColor: '#323130',
          fontSize: 14,
        },
      },

      title: {
        display: true,
        font: {
          size: 15,
          weight: 700,
          family: fontFamily,
        },
        text: title,
      },
    },

    scales: {
      'left-y-axis': {
        // type: 'linear',
        position: 'left',
        grid: {
          display: false,
        },
        ticks: {
          display: true,
        },
        title: {
          display: true,
          text: 'Total Calls',
          font: { size: 14, weight: 700, family: fontFamily },
        },
      },
      'right-y-axis': {
        // type: 'linear',
        position: 'right',
        min: 0,
        max: 100,
        grid: {
          display: true,
        },
        ticks: {
          display: true,
        },
        title: {
          display: true,
          text: 'Edit Rate',
          font: { size: 14, weight: 700, family: fontFamily },
        },
      },
      x: {
        ticks: {
          display: showXLabels,
        },
        grid: {
          display: false,
        },
        title: {
          display: true,
          text: nameXAxis,
          padding: 3,
          font: { size: 14, weight: 700, family: fontFamily },
        },
      },
    },
  };

  return (
    <Chart
      ref={chartRef}
      type="bar"
      height={height}
      data={data as any}
      options={options as any}
    />
  );
}
